<template>
  <b-form-group
    label="TCKN / Vergi No"
    label-for="tax_no"
  >
    <b-form-input
      id="tax_no"
      v-model="dataItem.tax_no"
      placeholder="TCKN / Vergi No"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TaxNo',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
  },
}
</script>
